import { notification } from "antd";
import { lazy, Suspense } from "react";
import { Redirect, Switch } from "react-router";
import { Route } from "react-router-dom";
import { getTokenInfo, linkDepandOndefaultPageOnWeb } from "src/common/service";
import auth from "src/hoc/auth";
import SupplierPublicCertificate from "src/pages/Supplier/Edit/SupplierPublicCertificate";

const Main = lazy(() => import("./Main"));
const PublicRouter = lazy(() => import("src/Routing/public-router"));
const Unauthorized = lazy(() =>
  import("../pages/Unauthorized/Unauthorized").then((module) => ({
    default: module.Unauthorized,
  })),
);

// We shouldn't do any change here
export const MainRouter = () => {
  // debugger;
  const tokenInfo = getTokenInfo(); // Get token info
  const isRemoteUser = tokenInfo?.Role === "RemoteUser";

  notification.config({
    placement: "top",
    maxCount: 3,
    top: 12,
  });
  return (
    <Suspense fallback={"Loading ..."}>
      <Switch>
        <Route
          path={["/login"]}
          component={auth(PublicRouter, [], true, true)}
        />
        <Route
          path={["/update/supplier-certificate/:organizationId/:id"]}
          component={auth(PublicRouter, [], true, false)}
        />
        {/* <Route path={["/unauthorized"]} exact component={Unauthorized} /> */}
        <Route
          path={"/unauthorized"}
          exact
          render={() =>
            isRemoteUser ? <Unauthorized /> : <Redirect to="/dashboard" />
          }></Route>
        {/* Default route redirect */}
        {/* <Route
          exact
          path="/"
          render={() =>
            defaultPageOnWeb ? (
              <Redirect to={linkDepandOndefaultPageOnWeb(defaultPageOnWeb)} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        /> */}
        <Route path={["/"]} component={auth(Main, [])}></Route>
      </Switch>
    </Suspense>
  );
};
